export default [
    ['IS', '独立系统'],
    ['CC', '通用组件'],
]
